import { render } from "./Iliopoulou.vue?vue&type=template&id=0d3a78bd"
import script from "./Iliopoulou.vue?vue&type=script&lang=js"
export * from "./Iliopoulou.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__